export const palette = ["e4f5fe", "f4eee9", "faf0f3", "f0f0ff", "f9f9f9"]
